import React from 'react';
import { PaymentMethod } from "../use-payment-hook";
import PaymentError from "./payment-error";
import PaymentSuccess from "./payment-success";

type Props = {
    title: string
    invoiceNumber?: string
    invoiceUrl?: string
    show: boolean
    status: 'success' | 'error'
    handleOk?: () => void
    handleClose?: () => void
    paymentMethod: PaymentMethod | undefined
    tryAgain: () => void
    showTryAgain: boolean
    showContinue: boolean
    isUpgradePlan: boolean
    lookupKey: string
}

export const PaymentStatus: React.FC<Props> = ({
    title,
    invoiceNumber,
    show,
    handleOk,
    status,
    handleClose,
    invoiceUrl,
    tryAgain,
    paymentMethod,
    showTryAgain,
    showContinue,
    isUpgradePlan,
    lookupKey
}) => {
    return (
        <>
            <PaymentSuccess
                title={title}
                invoiceNumber={invoiceNumber}
                invoiceUrl={invoiceUrl}
                show={show && status === 'success'}
                handleOk={handleOk}
            />
            <PaymentError
                title={title}
                show={show && status === 'error'}
                handleClose={handleClose}
                tryAgain={tryAgain}
                paymentMethod={paymentMethod}
                showTryAgain={showTryAgain}
                showContinue={showContinue}
                handleContinue={handleOk}
                isUpgradePlan={isUpgradePlan}
                lookupKey={lookupKey}
            />
        </>
    )
}